import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faPencil, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellEditEndingEventArgs, DataMap, FlexGrid } from '@grapecity/wijmo.grid'
import { ComboBox } from '@grapecity/wijmo.input'

import { Grid, Group, GroupCriterion, ListItem, ModalBackDrop, ModalSize, RepositoryModal, User } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GroupCriteriaComponent } from './group-criteria.component'

@Component({
    templateUrl: './group.component.html',
    standalone: true,
    imports: [FormsModule, ActionToolbarCount, ActionToolbarSearchComponent, FaIconComponent, WjGridModule, WjGridFilterModule],
})
export class GroupComponent extends RepositoryModal<Group> implements OnInit {
    faXmark = faXmark
    faPencil = faPencil
    faPlus = faPlus

    grid: Grid<User>
    criteriaGrid: Grid<GroupCriterion>
    users: User[] = []
    criteriaData: any

    criteriaTypes = [
        new ListItem('classes', 'Class'),
        new ListItem('prDept', 'PR Dept'),
        new ListItem('earnCodes', 'Earn Code'),
        new ListItem('prGroups', 'PR Group'),
        new ListItem('positionCodes', 'Position Code'),
    ]
    criteriaMap = new DataMap(this.criteriaTypes, 'value', 'display')
    operatorList = [new ListItem('==', 'Include'), new ListItem('!=', 'Exclude')]
    operatorMap = new DataMap(this.operatorList, 'value', 'display')

    criteria: GroupCriterion[] = []

    positionCodeMap!: DataMap
    prGroupMap!: DataMap
    earnCodeMap!: DataMap
    prDeptMap!: DataMap

    constructor() {
        super()
        this.grid = new Grid<User>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [item.displayName, item.positionCode, item.jobTitle, item.prgroup, item.prdept, item.earnCode, item.stdClass])
            .isReadOnly(false)

        this.criteriaGrid = new Grid<GroupCriterion>(this.services)
    }

    ngOnInit() {
        this.users = this.services.data.users.items.slice()
        this.users.forEach(x => {
            const match = this.target.groupUsers.find(y => y.userId === x.id)
            if (match) {
                x['include'] = match.include
                x['exclude'] = match.exclude
            } else {
                x['include'] = false
                x['exclude'] = false
            }
        })

        this.grid.items = this.users.filter(x => x.active)

        const groupController = this.editOptions.initializeParams as GroupComponent
        this.criteriaData = groupController.criteriaData

        if (this.target.groupCriteria && this.target.groupCriteria.length > 0) {
            this.criteria = this.target.groupCriteria

            this.criteria.forEach(x => {
                x.attributeValueName = this.criteriaData[x.attributeName].find(y => y.key === x.attributeValue)?.value
            })
        }
        this.criteriaGrid.items = this.criteria

        this.positionCodeMap = groupController.positionCodeMap
        this.prGroupMap = groupController.prGroupMap
        this.earnCodeMap = groupController.earnCodeMap
        this.prDeptMap = groupController.prDeptMap
    }

    cellBeginningEdit(flexGrid: FlexGrid, args: CellEditEndingEventArgs) {
        if (flexGrid.columns[args.col].binding !== 'attributeValue') return

        const item = flexGrid.rows[args.row].dataItem as GroupCriterion
        const type = item.attributeName
        const editor = flexGrid.activeEditor
        if (editor && editor instanceof ComboBox) {
            const typeData = this.criteriaData[type]
            const typesList = typeData.map(x => new ListItem(x.key, x.value))
            editor.itemsSource = typesList
        }
    }

    getAttrValues(cell) {
        const type = cell.item.attributeName
        const typeData = this.criteriaData[type]
        return typeData.map(x => new ListItem(x.key, x.value))
    }

    protected onBeforeSave() {
        if (!this.target.name) {
            this.services.notification.error('Group name is required')
            return false
        }

        this.target.groupUsers = this.users
            .filter(x => x['include'] || x['exclude'])
            .map(x => ({
                groupId: this.target.id,
                userId: x.id,
                include: x['include'],
                exclude: x['exclude'],
            }))

        this.target.groupCriteria = this.criteria
        return super.onBeforeSave()
    }

    toggleAllCheckboxes(event: Event) {
        const checkbox = event.target as HTMLInputElement
        if (checkbox.id === 'include') this.grid.view.items.forEach(x => (x['include'] = checkbox.checked))
        else this.grid.view.items.forEach(x => (x['exclude'] = checkbox.checked))
        this.grid.refresh()
    }

    addEditItem(isAdding: boolean) {
        console.log(isAdding)
        const ref = this.services.modals.open(GroupCriteriaComponent, ModalSize.small, ModalBackDrop.darkAndActive)
        const instance = ref.componentInstance as GroupCriteriaComponent

        instance.isAdding = isAdding
        if (isAdding) {
            instance.target = new GroupCriterion()
        } else {
            instance.target = this.services.utility.copy(this.criteriaGrid.selectedItem)
        }
        instance.criteriaData = this.criteriaData
        ref.result.then(
            () => {
                if (isAdding) {
                    this.criteria.push(instance.target)
                } else {
                    const index = this.criteria.indexOf(this.criteriaGrid.selectedItem)
                    this.criteria[index] = instance.target
                }
                this.criteriaGrid.refresh()
                console.log(instance.target)
            },
            () => {
                //
            },
        )
    }

    deleteCriteria() {
        const index = this.criteria.indexOf(this.criteriaGrid.selectedItem)
        this.criteria.splice(index, 1)
        this.criteriaGrid.refresh()
    }
}
